import { render, staticRenderFns } from "./UpChat.vue?vue&type=template&id=8b277f0e&lang=pug"
import script from "./UpChat.vue?vue&type=script&lang=js"
export * from "./UpChat.vue?vue&type=script&lang=js"
import style0 from "./UpChat.vue?vue&type=style&index=0&id=8b277f0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports